import { Flex, Page, Text } from '@servicetitan/anvil2';
import { FC } from 'react';
import ProblemsImg from '../assets/problems.svg';
import * as Styles from './page-401.module.less';

export const Page401: FC<{ title: string; message: string }> = ({ message, title }) => (
    <Page data-cy="ish-error-401-page">
        <Page.Content>
            <Flex
                direction="column"
                gap="2"
                className={Styles.content}
                justifyContent="center"
                alignItems="center"
            >
                <img src={ProblemsImg} alt="Problem" width={300} height={166} />
                <Text el="h1" size="medium" variant="headline" data-cy="ish-error-401-title">
                    {title}
                </Text>
                <Text data-cy="ish-error-401-message" subdued>
                    {message ? message : 'Unauthorized'}
                </Text>
            </Flex>
        </Page.Content>
    </Page>
);
